import { ConfigProvider } from '@alife/cn-ui';
import { componentName } from 'src/const';
import View from 'src/view';
const Index = ConfigProvider.config(View, {
    componentName,
});
Index.displayName = componentName;
export default Index;
